import Tabs from './Tabs.vue'
import TabPane from './TabPane.vue'

// 定义组件名称
const TABS_NAME = 'OlaTabs'
const TAB_PANE_NAME = 'OlaTabPane'

Tabs.Pane = TabPane

/**
 * 安装 Tabs 组件
 * @param {import('vue').App} app - Vue 应用实例
 */
Tabs.install = function(app) {
  app.component(TABS_NAME, Tabs)
  app.component(TAB_PANE_NAME, TabPane)
}

export { Tabs, TabPane }
export default Tabs